module.exports = __webpack_public_path__ + "static/img/oil.cb411d4.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/oil.svg
// module id = +sGW
// module chunks = 1